import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  Box,
  TextField,
  Dialog,
  Autocomplete,
  useTheme,
  styled,
  Switch,
} from '@mui/material';
import CustomInput from '../../../../../../components/shared/CustomInput';
import BackButton from '../../../../../../components/shared/BackButton';

import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import CustomButton from '../../../../../../components/shared/CustomButton';
const CategoryMenuEditMobile = (props) => {
  const {
    theme,
    today,
    AntSwitch,
    // *--- cata value
    categoryEditInputDatas,
    setCategoryEditInputDatas,
    // *--- Data
    subsidiaryCategory,
    subsidiaryCategoryLoading,
    typeCategory,
    // *--- Handler
    handleBackButton,
    handleDelete,
    handleEdit,
    handleAddImage,
    handleDeleteImage,
    handlePreviewImage,
    handleClosePreviewImage,
  } = props;
  return (
    <Grid container columns={12} spacing={2}>
      {/* //* Back */}
      <Grid item xs={10} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BackButton handleClick={handleBackButton} />
        <Typography
          sx={{
            ml: '8px',
            fontSize: '16px',
            fontWeight: '600',
          }}
        >
          Edit Category
        </Typography>
      </Grid>
      {/* //* Subsidiary */}
      <Grid item xs={12}>
        <Autocomplete
          sx={{ bgcolor: '#FAFAFA', borderRadius: '8px' }}
          value={categoryEditInputDatas.subsidiary}
          options={subsidiaryCategory}
          getOptionLabel={(option) => option.name}
          onChange={(event, newValue) => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              subsidiaryId: parseInt(newValue.id),
              subsidiary: newValue,
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Subsidiary*"
              sx={{
                bgcolor: '#FAFAFA',
                borderRadius: '8px',
                width: '100%',
                '.MuiOutlinedInput-input': {
                  fontSize: '12px',
                  padding: '12px',
                },
              }}
            />
          )}
        />
      </Grid>
      {/* //* Name */}
      <Grid item xs={12}>
        <CustomInput
          sx={{
            bgcolor: '#FAFAFA',
            borderRadius: '8px',
            width: '100%',
            '.MuiOutlinedInput-input': {
              fontSize: '12px',
              padding: '12px',
            },
          }}
          placeholder="Name*"
          value={categoryEditInputDatas.name}
          onChange={(e) => {
            if (e.target.value.length <= 30) {
              setCategoryEditInputDatas({
                ...categoryEditInputDatas,
                name: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 5 character
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryEditInputDatas.name.length}/30
          </Typography>
        </Box>
      </Grid>
      {/* //* Photo */}
      <Grid item xs={12} sx={{ minHeight: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            pb: `${categoryEditInputDatas.photo.length === 0 ? '16px' : '9px'}`,
          }}
        >
          <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
            Photo
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '500',
              color: '#9E9D9D',
            }}
          >
            ( max size : 2MB )
          </Typography>
        </Box>
        {categoryEditInputDatas.isMaxSizePhoto && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ErrorOutlineIcon
              sx={{
                fontSize: '8px',
                fontWeight: '500',
                color: theme.palette.warning.main,
                mr: '4px',
              }}
            />
            <Typography
              sx={{
                fontSize: '8px',
                fontWeight: '500',
                color: theme.palette.warning.main,
              }}
            >
              The photo can't be more than 2MB
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {categoryEditInputDatas.photoUrls.length === 0 && (
              <Box
                sx={{
                  height: '54px',
                  width: '54px',
                  aspectRatio: '1/1',
                  borderRadius: '8px',
                  bgcolor: '#F5F5F5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderStyle: 'dashed',
                  borderColor: '#9E9D9D',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <ImageOutlinedIcon
                  sx={{ color: '#9E9D9D', fontSize: '28px' }}
                />
              </Box>
            )}
            {categoryEditInputDatas.photoUrls.map((input, index) => (
              <Box
                sx={{
                  position: 'relative',
                  overflow: 'visible',
                  padding: '7px',
                }}
                key={index}
              >
                <CancelIcon
                  sx={{
                    position: 'absolute',
                    fontSize: '20px',
                    top: 1,
                    right: 1,
                    zIndex: +1,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDeleteImage(input)}
                />
                <Box
                  component="img"
                  src={process.env.REACT_APP_API_IMAGE_BASE_URL + '/' + input}
                  sx={{
                    height: '54px',
                    width: '54px',
                    aspectRatio: '1/1',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => handlePreviewImage(input)}
                />
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: 'flex',
              mb: '7px',
              ml: '20px',
              alignItems: 'center',
            }}
          >
            {categoryEditInputDatas.photoUrls.length < 3 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  document.getElementById('input_img').click();
                }}
              >
                <input
                  accept="image/*"
                  id="input_img"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleAddImage}
                />
                <AddIcon sx={{ fontSize: '16px' }} />
                <Typography sx={{ fontSize: '12px', fontWeight: '600' }}>
                  Add More
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      {/* //* Dialog Photo */}
      {categoryEditInputDatas.linkPreviewPhoto !== '' && (
        <Dialog
          open={categoryEditInputDatas.isPreviewPhoto}
          onClose={handleClosePreviewImage}
        >
          <Box
            component="img"
            src={
              process.env.REACT_APP_API_IMAGE_BASE_URL +
              '/' +
              categoryEditInputDatas.linkPreviewPhoto
            }
            sx={{ width: '100%', aspectRation: '1/1' }}
          />
        </Dialog>
      )}
      {/* //* Description */}
      <Grid item xs={12}>
        <CustomInput
          sx={{
            width: '100%',
            bgcolor: '#FAFAFA',
            '.MuiOutlinedInput-input': {
              fontSize: '12px',
              padding: '12px',
            },
          }}
          placeholder="Description"
          value={categoryEditInputDatas.description}
          onChange={(e) => {
            if (e.target.value.length <= 250) {
              setCategoryEditInputDatas({
                ...categoryEditInputDatas,
                description: e.target.value,
              });
            }
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            Enter at least 20 character
          </Typography>
          <Typography
            sx={{
              fontSize: '8px',
              fontWeight: '400',
              color: '#9E9D9D',
              mt: '4px',
            }}
          >
            {categoryEditInputDatas.description.length}/250
          </Typography>
        </Box>
      </Grid>
      {/* //* Schedule */}
      <Grid item xs={12} sx={{}}>
        <Box sx={{ display: 'flex', minWidth: '100%' }}>
          <DesktopDatePicker
            inputFormat="DD/MM/YYYY"
            value={categoryEditInputDatas.schedule}
            onChange={(newValue) => {
              if (categoryEditInputDatas.scheduleType !== 'now') {
                setCategoryEditInputDatas({
                  ...categoryEditInputDatas,
                  schedule: newValue,
                });
              } else {
                setCategoryEditInputDatas({
                  ...categoryEditInputDatas,
                  schedule: today,
                });
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  width: '100%',
                  bgcolor: '#FAFAFA',
                  '.MuiOutlinedInput-input': {
                    fontSize: '12px',
                    padding: '12px',
                  },
                }}
              />
            )}
          />
        </Box>
      </Grid>
      {/* //* STATUS */}
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>
          Publish
        </Typography>
        <AntSwitch
          checked={categoryEditInputDatas.publish}
          onChange={(e) => {
            setCategoryEditInputDatas({
              ...categoryEditInputDatas,
              publish: !categoryEditInputDatas.publish,
            });
          }}
        />
      </Grid>
      {/* //* Button */}
      <Grid
        item
        xs={12}
        sx={{ mt: '28px', display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <CustomButton
          // disabled={!isSubmitAvailable}
          onClick={handleDelete}
          variant="contained"
          sx={{
            width: '100%',
            bgcolor: theme.palette.error.main,
          }}
        >
          Delete
        </CustomButton>
        <CustomButton
          // disabled={!isSubmitAvailable}
          onClick={handleEdit}
          variant="contained"
          sx={{
            width: '100%',
          }}
        >
          Edit
        </CustomButton>
      </Grid>
    </Grid>
  );
};

export default CategoryMenuEditMobile;
